import { WEBSITE_TITLE } from "../config";

export default function setDocumentTitle(title?: string): void {
  document.title = title ? `${WEBSITE_TITLE} • ${title}` : WEBSITE_TITLE;
}
